import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "gallery";
const path_type: string = "gallery-type"

export type galleryListType = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
    id_gallery_type?: number;
    type: string; // IMAGE OR VIDEO
}
export type galleryDetailType = {
    is_public: boolean;
    id_gallery_type: number | null;
    gallery_category: string;
    start_date: string | null;
    end_date: string | null,
    gallery_name: string,
    media_files: { id_media_file: number | null, gallery_link: string, id_gallery_file?: number }[],
    is_draft: boolean;
}

export class GalleryApi extends BaseAPI {
    static list(query: galleryListType): Promise<AxiosResponse> {
        return this.api.get(`${path}`, {
            params: query
        })
    }
    static create(body: galleryDetailType): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_gallery: number, body: galleryDetailType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_gallery}`, body)
    }
    static findOne(id_gallery: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_gallery}`)
    }
    static delete(id_gallery: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_gallery}`)
    }
    static update_status(id_gallery: number, body: { is_public: boolean }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_gallery}/status-gallery`, body)
    }


    static findDropdownType(): Promise<AxiosResponse> {
        return this.api.get(`${path_type}/dropdown`)
    }
}